module.exports = {"pipeline":{"name":"pipeline-paging","title":"分页按钮","type":"qs-other","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-paging/package.json
// module id = 258
// module chunks = 1